let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1U6At")).then(() => parcelRequire('gb3Xv'));